<template>
    <div class="custom-select" :class="customClass" :style="customStyle" ref="selectContainer">

        <div @click="toggleDropdown" class="input-wrapper">
            <input v-if="searchable"
                   v-model="searchTerm"
                   @focus="showDropdown = true"
                   @input="eventos"
                   :placeholder="place_holder()"
                   :disabled="disabled" />
            <span :class="['icon arrow-downward', { active: showDropdown }]"></span>
        </div>

        <!-- Dropdown de opções -->
        <div v-if="showDropdown" class="dropdown">

            <div :class="{ selected: isSelected(Proximo_Evento) }" @click="selectOption(Proximo_Evento)" v-if="Proximo_Evento.idEvento > 0">
                <div class="opt-proximo">Proximo:</div>
                <div class="option">{{ Proximo_Evento.nmEvento }} - {{ Proximo_Evento.dsInfo }}</div>
            </div>

            <div class="opt-proximo" v-if="lstEventosFuturos.length > 0">Futuros:</div>
            <div :class="{ selected: isSelected(option) }" class="option" @click="selectOption(option)" v-for="(option, index) in lstEventosFuturos" :key="index">
                <div>{{ option.nmEvento }} - {{ option.dsInfo }}</div>
            </div>

            <div class="opt-proximo" v-if="lstEventosRealizados.length > 0">Já Realizados:</div>
            <div :class="{ selected: isSelected(option) }" class="option" @click="selectOption(option)"
                 v-for="(option, index) in lstEventosRealizados" :key="index">
                <div>{{ option.nmEvento }} - {{ option.dsInfo }}</div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'DropdowEventos',
        props: {
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: Object,
                default: () => ({ idEvento: 0 }),
            },
            placeholder: {
                type: String,
                default: "",
            },
            searchPlaceholder: {
                type: String,
                default: "Pesquise...",
            },
            searchable: {
                type: Boolean,
                default: false,
            },
            closeOnSelect: {
                type: Boolean,
                default: true,
            },
            clearOnSelect: {
                type: Boolean,
                default: true,
            },
            min: {
                type: Number,
                default: 1,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            customClass: {
                type: String,
                default: "",
            },
            customStyle: {
                type: String,
                default: "",
            },
            reset: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                DataAtual: new Date(),

                searchTerm: "",
                showDropdown: false,
                lstEventos: [],
                EventoSelected: { idEvento: 0 },
                Proximo_Evento: { idEvento: 0 },
                lstEventosFuturos: [],
                lstEventosRealizados: []
            };
        },
        methods: {
            place_holder() {
                if (this.showDropdown) {
                    return this.searchPlaceholder
                } else {
                    if (this.EventoSelected.idEvento > 0) {
                        return this.EventoSelected.nmEvento + '-' + this.EventoSelected.dsInfo;
                    } else {
                        return this.placeholder;
                    }
                }
            },
            toggleDropdown() {
                this.showDropdown = true;
            },
            selectOption(option) {
                if (this.clearOnSelect) {
                    this.EventoSelected = option;
                    this.$emit("input_evento", this.EventoSelected);
                    if (this.closeOnSelect) {
                        this.showDropdown = false;
                    }
                    this.searchTerm = "";
                }
            },
            clearSelection() {
                this.$emit("input", { idEvento: 0 });
            },
            isSelected(option) {
                return this.value.idEvento === option.idEvento;
            },
            handleClickOutside(event) {
                if (this.showDropdown && !this.$refs.selectContainer.contains(event.target)) {
                    this.showDropdown = false;
                }
            },
            converterParaData(dataString) {
                const [dia, mes, ano] = dataString.split('/');
                return new Date(`${ano}-${mes}-${dia}`);
            },
            zera_eventos() {
                this.Proximo_Evento = { idEvento: 0 };
                this.lstEventosFuturos = [];
                this.lstEventosRealizados = [];

            },
            zera_EventoSelect() {
                this.EventoSelected = { idEvento: 0, };
                this.$emit("return_dropEvento_reset");
            },
        },
        watch: {
            reset(n, o) {
                if (n == true) {
                    this.zera_EventoSelect();
                }
            },
            searchTerm(newValue) {
                this.zera_eventos();
                if (this.lstEventos.length > 0) {
                    var temp_list = this.lstEventos;

                    temp_list = this.options.filter(evento =>
                        evento.nmEvento.toLowerCase().includes(newValue.toLowerCase())
                    );

                    if (temp_list.length > 0) {
                        var dtInicioEventoDate = this.converterParaData(temp_list[0].dtInicio);

                        if (dtInicioEventoDate >= this.DataAtual) {
                            this.Proximo_Evento = temp_list[0];
                            temp_list.splice(0, 1);
                        }

                        this.lstEventosFuturos = temp_list.filter(evento => {
                            var dtInicioEventoDate = this.converterParaData(evento.dtInicio);
                            return dtInicioEventoDate >= this.DataAtual;
                        });

                        temp_list = temp_list.filter(evento => {
                            var dtInicioEventoDate = this.converterParaData(evento.dtInicio);
                            return dtInicioEventoDate < this.DataAtual;
                        });

                        this.lstEventosRealizados = temp_list;
                    }

                }
            },
            options(newValue) {
                this.zera_eventos();
                this.lstEventos = newValue;

                if (this.lstEventos.length > 0) {
                    var temp_list = this.lstEventos;

                    var dtInicioEventoDate = this.converterParaData(temp_list[0].dtInicio);

                    if (dtInicioEventoDate >= this.DataAtual) {
                        this.Proximo_Evento = temp_list[0];
                        temp_list.splice(0, 1);
                    }

                    this.lstEventosFuturos = temp_list.filter(evento => {
                        var dtInicioEventoDate = this.converterParaData(evento.dtInicio);
                        return dtInicioEventoDate >= this.DataAtual;
                    });

                    temp_list = temp_list.filter(evento => {
                        var dtInicioEventoDate = this.converterParaData(evento.dtInicio);
                        return dtInicioEventoDate < this.DataAtual;
                    });

                    this.lstEventosRealizados = temp_list;
                }
            },
            showDropdown(newValue) {
                if (newValue) {
                    document.addEventListener("click", this.handleClickOutside);
                } else {
                    document.removeEventListener("click", this.handleClickOutside);
                }
            },
        },
    };
</script>

<style scoped>
    .custom-select {
        position: relative;
        width: 100%;
    }

    .input-wrapper {
        display: flex;
        align-items: center;
        border-radius: 4px;
        padding: 4px;
        cursor: pointer;
    }

    input {
        border: none;
        outline: none;
        width: 100%;
        font-size: 0.8rem;
    }

    .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background: white;
        border: 1px solid #ccc;
        max-height: 200px;
        overflow-y: auto;
        z-index: 10;
    }

    .option {
        padding: 4px;
        padding-left: 20px;
        cursor: pointer;
        font-size: 12px;
    }

        .option:hover {
            background-color: #e9ecef;
        }

        .option.selected {
            background-color: #007bff;
            color: white;
        }

    .no-options {
        padding: 4px;
        text-align: center;
    }

    .selected-tag {
        border-radius: 4px;
        display: block;
        font-size: 0.8rem;
        color: #808080;
        width: 100%;
    }

    .icon.arrow-downward {
        color: #999;
        border-style: solid;
        border-width: 4px 4px 0;
        border-color: #999 transparent transparent;
        cursor: pointer;
        transition: transform 0.3s ease;
        margin-left: 4px;
    }

        .icon.arrow-downward.active {
            transform: rotate(180deg);
        }

    .upcoming-events {
        font-size: 0.8rem;
        font-weight: bold;
    }

    .opt-proximo {
        font-size: 13px;
        border-top: 1px solid #e5e5e5;
        padding-top: 2px !important;
        padding: 5px;
        color: #9f3029;
        font-weight: bold;
    }
</style>